<template>
     <span v-if="hasTranslation">
      {{ translatedText }}           
    </span>
</template>

<script>
import adminStore from '@/stores/adminstore'
import { mapActions, mapState, mapGetters } from 'pinia'

// import { defineAsyncComponent } from 'vue'

export default {
  name: 'I18nSpan',
  components: {},
  props: {
    i18nkey: {
        type: String,
        required: true
    }
  },
  data() {
    return {
        translatedText: '',
        hasTranslation: false
    }
  },
  beforeMount() {
   // console.log('i18nSpan GOT BEFORE MOUNT !')
  },
  mounted() {
      this.geti18nTranslation(this.i18nkey).then(result => {
   //     console.log('i18nSPAN TRANSLATE TEXT (%s)', result)
            this.translatedText = result
            this.hasTranslation = true
       })
  },
  methods: {
    ...mapActions(adminStore, ['geti18nTranslation']),
    ...mapGetters(adminStore,['getTranslationMap'])
  }
}
</script>

<style scoped>

</style>